<div class="reservation__container">
  <div class="settings d-flex flex-row">
    <!-- <mat-icon>more_vert</mat-icon> -->
  </div>
  <div class="reservation__header d-flex flex-row">
    <div>
      <h4>{{ 'RESERVATIONS.RESERVATIONS' | translate }}</h4>
    </div>
    <div>
      <!-- <div>
          Search Component
      </div> -->
    </div>
  </div>
</div>

<div class="reservation__tabs-container">
  <div class="reservation__reservationtabs d-flex flex-row">
    <div>
      <p-tabView (onChange)="getReservationsByStatus($event)" [activeIndex]="selectedTab" #tabView>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <i class="pi pi-fw pi-bell"></i>
            <label style="cursor: pointer;">{{'RESERVATIONS.PENDING'|translate}} <span
              class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <label style="cursor: pointer;">{{'RESERVATIONS.CONFIRMED' | translate }} <span
              class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <label style="cursor: pointer;">{{'RESERVATIONS.DECLINED' | translate }}<span class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <label style="cursor: pointer;">{{'RESERVATIONS.SEATED' | translate }}<span class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
          </div>
        </p-tabPanel>
        <p-tabPanel>
          <ng-template pTemplate="header">
            <label style="cursor: pointer;">{{'RESERVATIONS.CANCELED' | translate }}<span class="color_mono_txt"></span></label>
          </ng-template>
          <div>
            <ng-container *ngTemplateOutlet="reservationsTemplate"></ng-container>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>

  </div>
</div>

<ng-template #reservationsTemplate>
  <ng-container *ngIf="reservationList?.length != 0 && !loadingPage">
    <ng-container *ngFor="let reservation of reservationList">
      <div class="d-flex flex-row w-100">
        <app-reservation-item class="w-100" [reservation]="reservation"></app-reservation-item>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-container *ngIf="reservationList?.length === 0 && !loadingPage">
  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col-12 no-items">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img src="./assets/images/icons/reservations_empty@3x.png" alt="no-reservations" class="img-responsive">
          <p class="mt-2">{{ 'RESERVATIONS.NO_RESERVATIONS' | translate }}</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
